<template>
   <div class="right">
      <div class="title-box">
        <span class="curr">主要职责</span>
      </div>
      <div class="pt-30">
        <p>中国服务贸易协会信息技术服务委员会智库以“打造国内高端强库”为理念，坚持解放思想，推进改革创新，提倡不同学术观点和意见进行平等讨论，营造独立思考、互相切磋的良好氛围。 </p>

        <p>坚持以习近平新时代中国特色社会主义思想为指导,坚持实事求是、理论联系实际的原则,坚为党和政府科学决策、民主决策、依法决策提供重要支撑,采取理论与实践相结合、科学研究与成果转化相结合、人才培养与人才孵化相结合的“双轮驱动”工作方针,充分发挥资源优势，</p>

        <p>围绕信息技术服务行业创新新模式集中攻关，从哲学维度、方略维度、战术维度和全球视野展开深入研究，提供政策咨询。为政策制定、标准与诚信体系构建、品牌打造、人才培养提供决策咨询；积极参与产业理论研究，行业与区域发展研究，为行业和企业提供指导与咨询服务；广泛参与国际交流与合作，组织社会各界开展课题研究、学术交流、科研成果评审、人オ资源开发、人才智库建设与咨询等服务活动,为高质量建设信息技术服务产业提供理论支撑和智力支持。</p>
      </div>
   </div>
</template>
<script>
export default {
  data() {
    return {
      leftList: [
        '专家智库',
        '主要职责',
        '分会专家',
        '白皮书',
      ]
    }
  }
};
</script>
<style lang="less" scoped>

.right {
  width: 905px;
  background: #ffffff;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.05);
  padding: 30px;
  p {
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #5F5F6A;
    line-height: 28px;
    margin-bottom: 40px;
    text-indent: 2em;
  }
}

.title-box {
  padding: 0 0 21px 0;
  border-bottom: 1px solid #f8f8fb;
  span {
    font-size: 20px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: bold;
    color: #909097;
    line-height: 28px;
    margin-right: 40px;
    position: relative;
    &.curr {
      color: #1b252c;
      &::after {
        width: 96px;
        height: 2px;
        background: #0d53bc;
        content: "";
        position: absolute;
        bottom: -20px;
        left: 0;
      }
    }
  }
}
</style>
